<template>
  <div class="not-permission">
    <div class="content">
      <div class="permission-image f-l"><img src="../assets/403.png" alt></div>
      <div class="permission-text f-l" />
      <div class="permission-title">Sorry, you don't have access to this page.</div>
      <div class="bullshit__oops">403!</div>
      <router-link :to="{path: '/'}" class="bullshit__return-home">Return Home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: '403',
  data () {
    return {};
  },
  mounted () {
  },
  methods: {}
};
</script>

<style type="text/css" scoped>
  .not-permission {
    width: 100%;
    height: 100%;
  }

  .not-permission .content {
    width: 1000px;
    margin: 150px auto;
  }

  .not-permission .content .permission-image {
    width: 500px;
  }

  .not-permission .content .permission-image img {
    width: 100%;
  }

  .f-l {
    float: left;
  }

  .not-permission .content .permission-text div:nth-of-type(1) {
    font-size: 26px;
  }

  .permission-title {
    font-size: 30px;
    margin-top: 20px;
  }

  .not-permission .content .permission-text div:nth-of-type(2) span p:nth-of-type(1) {
    margin-top: 16px;
    margin-left: 30px;
  }

  .not-permission .content .permission-text div:nth-of-type(2) span p:nth-of-type(2) {
    margin-top: 16px;
    margin-left: 30px;
  }

  .not-permission .content .permission-text {
    padding-top: 150px;
    padding-left: 20px;
  }

  .bullshit__oops {
    font-size: 32px;
    font-weight: bold;
    line-height: 40px;
    color: #1482f0;
    opacity: 0;
    margin-top: 20px;
    margin-bottom: 20px;
    animation-name: slideUp;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }

  .bullshit__return-home {
    display: block;
    float: left;
    width: 110px;
    height: 36px;
    background: #1482f0;
    border-radius: 100px;
    text-align: center;
    color: #ffffff;
    opacity: 0;
    font-size: 14px;
    line-height: 36px;
    cursor: pointer;
    animation-name: slideUp;
    animation-duration: 0.5s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
  }

  @keyframes slideUp {
    0% {
      transform: translateY(60px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
